// Next Diamonds — Collection Sale Banner
// Drives the metafield-powered banner on every collection page.
// Reads window.ndPromo (set by snippets/nd-promo-data.liquid).
// Auto-hides when the sale ends.

(function () {
  'use strict';

  // When this much time or less remains, switch from "ENDS SOON" label
  // to the live countdown timer. Keep in sync with pdp-sale-banner.js.
  var TIMER_THRESHOLD_MS = 48 * 60 * 60 * 1000; // 48 hours

  function init() {
    var banner = document.querySelector('[data-nd-collection-banner]');
    if (!banner) return;
    var promo = window.ndPromo || {};
    var endTime = promo.saleEnd ? new Date(promo.saleEnd).getTime() : NaN;
    var pct = parseInt(promo.discountPercent, 10) || 0;

    if (!pct || !endTime || isNaN(endTime)) {
      banner.hidden = true;
      return;
    }

    var pctEl = banner.querySelector('[data-nd-discount-percent]');
    if (pctEl) pctEl.textContent = String(pct);

    // Sale name prefix from shop.metafields.custom.active_sale_name
    if (promo.saleName) {
      var nameEl = banner.querySelector('[data-nd-sale-name]');
      var sepEl  = banner.querySelector('[data-nd-name-sep]');
      if (nameEl) { nameEl.textContent = promo.saleName; nameEl.hidden = false; }
      if (sepEl)  { sepEl.hidden = false; }
    }

    if (promo.saleMessage) {
      var msgEl = banner.querySelector('[data-nd-sale-msg]');
      if (msgEl) msgEl.textContent = promo.saleMessage;
    }

    // Two display modes: "ENDS SOON" label (>48h out) vs live countdown (≤48h).
    var endsSoonEl = banner.querySelector('[data-nd-ends-soon]');
    var msgEl      = banner.querySelector('[data-nd-sale-msg]');
    var timerEl    = banner.querySelector('.nd-collection-banner__timer');

    function setMode(showTimer) {
      if (endsSoonEl) endsSoonEl.hidden = showTimer;
      if (msgEl)      msgEl.hidden      = !showTimer;
      if (timerEl)    timerEl.hidden    = !showTimer;
    }

    var days  = banner.querySelector('[data-nd-timer-days]');
    var hours = banner.querySelector('[data-nd-timer-hours]');
    var mins  = banner.querySelector('[data-nd-timer-mins]');
    var secs  = banner.querySelector('[data-nd-timer-secs]');

    function pad2(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var now = Date.now();
      var diff = endTime - now;
      if (diff <= 0) {
        banner.hidden = true;
        clearInterval(timer);
        return;
      }
      // > 48h from end → show "ENDS SOON" instead of the live timer.
      if (diff > TIMER_THRESHOLD_MS) {
        setMode(false);
        return;
      }
      // ≤ 48h → show the live countdown (existing behavior).
      setMode(true);
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (days)  days.textContent  = pad2(d);
      if (hours) hours.textContent = pad2(h);
      if (mins)  mins.textContent  = pad2(m);
      if (secs)  secs.textContent  = pad2(s);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
